import React, { useState } from 'react';
import styled, { css } from 'styled-components';

const TabControlContainer = styled(({ ...props }) => <div {...props} />)`
    display: flex;
    flex-basis: 100%;
    justify-content: flex-start;
    border-bottom: solid 0.1rem #ddd;
    position: relative;
    ${({ expandx }) =>
        expandx === 'true' &&
        css`
            margin-left: -1.337rem;
            margin-right: -1.337rem;
            padding: 0 1.337rem;
        `}
`;

const TabControl = styled(({ active, activeBackground, onClick, i, ...rest }) => (
    <button key={i} onClick={onClick} {...rest} tabIndex={active ? '-1' : '0'} />
))`
    color: ${(props) => (props.active ? props.theme.colors.brand.P8 : props.disabled ? `#ccc` : `#000`)};
    cursor: ${(props) => (props.disabled === false ? `pointer` : `not-allowed`)};
    min-width: 3rem;
    padding: 0.4rem 0.8rem;
    padding-bottom: ${(props) => (props.active ? `0.5rem` : `0.4rem`)};
    border-top-right-radius: 0.3rem;
    border-top-left-radius: 0.3rem;
    background: ${({ active, activeBackground }) => (active ? activeBackground ?? '#fff' : '#fff')};
    border-top: ${(props) =>
        props.active
            ? `
solid 0.1rem #ddd`
            : `solid 0.1rem transparent`};
    border-left: ${(props) => (props.active ? `solid 0.1rem #ddd` : `solid 0.1rem transparent`)};
    border-right: ${(props) =>
        props.active
            ? `
solid 0.1rem #ddd`
            : `solid 0.1rem transparent`};
    margin-bottom: ${(props) => (props.active ? `-0.1rem` : '0')};
    border-bottom: none;
`;

TabControl.defaultProps = {
    disabled: false,
    activeBackground: '#fff'
};

const TabsHeader = ({ tabControls, updateActive, active, expandHeaderX, activeBackground }) => (
    <TabControlContainer expandx={expandHeaderX?.toString() ?? 'false'}>
        {Object.keys(tabControls).map((v, i) => (
            <TabControl
                active={v === active}
                onClick={() => (tabControls[v].disabled !== true ? updateActive(v) : null)}
                i={i}
                key={i}
                disabled={tabControls[v].disabled}
                activeBackground={activeBackground}
            >
                {tabControls[v].label}
            </TabControl>
        ))}
    </TabControlContainer>
);

const TabsBody = styled.div`
    padding: 1rem;
`;

const TabbedContainer = ({ tabs, expandHeaderX, activeBackground }) => {
    let [activeTab, setActiveTab] = useState(Object.keys(tabs)[0]);

    const tabControls = Object.keys(tabs).reduce((agg, v, i) => {
        let { children, ...tab } = tabs[v];
        agg[v] = tab;
        return agg;
    }, {});
    return (
        <>
            <TabsHeader
                tabControls={tabControls}
                updateActive={setActiveTab}
                active={activeTab}
                expandHeaderX={expandHeaderX}
                activeBackground={activeBackground}
            />
            <TabsBody>
                {Object.entries(tabs).map(([i, v], index) => {
                    if (i === activeTab) {
                        return (
                            <div style={{}} key={index}>
                                {v.children}
                            </div>
                        );
                    } else {
                        if (v.alwaysMounted) {
                            return (
                                <div style={{ display: 'none' }} key={index}>
                                    {v.children}
                                </div>
                            );
                        } else {
                            return null;
                        }
                    }
                })}
            </TabsBody>
        </>
    );
};

TabbedContainer.defaultProps = {
    tabs: {}
};

export default TabbedContainer;
